import React, { Component } from 'react';
import { css } from 'emotion';

import Tooltip from '../../../../../common/components/core/Tooltip';
import DiscoAdsIntentListItem from './DiscoAdsIntentListItem';
import BranchLoader from '../../../../../../js/common/components/core/BranchLoader';

import Colors from '../../../../../../styles/Colors';

import {
  INTENT_SEARCH_RESULTS,
  SELECTED_INTENTS
} from '../../discoAdsConstants';

const styles = {
  intentListContainer: css({
    backgroundColor: Colors['@white'],
    height: '450px',
    paddingRight: '24px',
    paddingLeft: '24px',
    overflow: 'scroll'
  }),
  columnHeadersRow: css({
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: '10px',
    paddingTop: '10px',
    color: Colors['@boulder'],
    fontSize: '14px'
  }),
  columnHeaders: css({
    fontWeight: '600',
    display: 'inline-block'
  }),
  selectedIntentsRightColumnHeaderContainer: css({
    marginRight: '45px'
  }),
  numberOfIntents: css({
    marginLeft: '2px'
  }),
  infoIconContainer: css({
    marginLeft: '5px'
  }),
  infoIcon: css({
    marginBottom: '2px'
  })
};

class DiscoAdsIntentList extends Component {
  _fetchTypeSpecificProps = () => {
    const { type, onIntentClick, onIntentBidChange } = this.props;
    if (type === INTENT_SEARCH_RESULTS) {
      return {
        onSearchResultClick: onIntentClick
      };
    }
    return {
      onRemoveIntentFromSelected: onIntentClick,
      onIntentBidChange: onIntentBidChange
    };
  };

  _renderIntentList = () => {
    const { data, type, pageIsLoading } = this.props;
    if (type === INTENT_SEARCH_RESULTS && pageIsLoading) {
      return (
        <BranchLoader
          size="xs"
          className="intents-modal-branch-loader-container"
        />
      );
    }
    const typeSpecificProps = this._fetchTypeSpecificProps();
    return data.map((intent, index) => (
      <DiscoAdsIntentListItem
        key={index}
        rowIndex={index}
        intent={intent}
        type={type}
        {...typeSpecificProps}
      />
    ));
  };

  render() {
    const {
      intentListContainer,
      columnHeadersRow,
      columnHeaders,
      numberOfIntents,
      selectedIntentsRightColumnHeaderContainer,
      infoIconContainer,
      infoIcon
    } = styles;
    const { data, type, tooltipBody } = this.props;
    return (
      <div className={intentListContainer}>
        <div className={columnHeadersRow}>
          <div>
            <div className={columnHeaders}>Intents</div>
            {type === INTENT_SEARCH_RESULTS && (
              <span className={numberOfIntents}>{`(${data.length})`}</span>
            )}
          </div>
          <div
            className={
              type === SELECTED_INTENTS
                ? selectedIntentsRightColumnHeaderContainer
                : null
            }
          >
            <div className={columnHeaders}>
              {type === INTENT_SEARCH_RESULTS ? 'Popularity' : 'Max CPC'}
            </div>
            <Tooltip
              body={tooltipBody}
              className={infoIconContainer}
              infoIconClassName={infoIcon}
            />
          </div>
        </div>
        {this._renderIntentList()}
      </div>
    );
  }
}

export default DiscoAdsIntentList;
